/*  MUI  */
import { Box, FormControlLabel, Typography } from '@mui/material';

/* Shared */
import { AuvikSwitch } from 'application/Shared/Components/Switches';
import { TooltipQ } from 'application/Shared/Components/Tooltips';
import { FontSizes } from 'application/Shared/Constants';

/*  React  */
import React from 'react';
import { useTranslation } from 'react-i18next';

/* Internal Components */
import { useManagedTableV2Context } from '../ManagedTableV2ContextProvider';

export const ManagedTableAutoupdate = () => {
    const { t } = useTranslation();
    const { autoupdate, handleSwitchChange } = useManagedTableV2Context();

    return (
        <FormControlLabel
            control={
                <Box>
                    <AuvikSwitch
                        checked={autoupdate}
                        onChange={handleSwitchChange}
                        inputProps={{
                            'aria-label': 'controlled'
                        }}
                    />
                </Box>
            }
            label={
                <Box display="flex" alignItems="center">
                    <Typography
                        variant="p"
                        style={{
                            marginLeft: '8px'
                        }}
                    >
                        {t('Common.autorefresh')}
                    </Typography>
                    <TooltipQ
                        text={t('Devices.autoupdate')}
                        size={FontSizes[1]}
                    />
                </Box>
            }
            style={{ margin: 0 }}
        />
    );
};
